module.exports = __webpack_public_path__ + "img/gdcp.d9aabd6d.svg";